import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import { useDispatch } from "react-redux";

import { Form } from "react-bootstrap";
import * as Yup from "yup";
import { Field, Formik } from "formik";

export default function RestlessMarkReviewDialog({ row, id, show, onHide, markContentAsReview}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchImageToken);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  
  const ModerationSchema = Yup.object().shape({
    reviewNotes: Yup.string()
        .required("Comments is a required field.")
        .nullable()
  });

  const getInputClasses = (fieldname, touched, errors) => {
    if (touched[fieldname] && errors[fieldname]) {
      return "is-invalid";
    }
    return "";
  };

  const initialValues = {
    reviewNotes: ""
  };

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => markContentAsReview(row, values.reviewNotes)}
          validationSchema={ModerationSchema}
        >
          {({
            values,
            errors,
            handleChange,
            status,
            touched,
            handleSubmit,
            getFieldProps,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header>
                <div className="">Monitor {row.type}</div>
              </Modal.Header>
              <Modal.Body>
       
                          <div className="row">
                            <div className="col">
                            {errors.reviewNotes ? (
                          <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                            <div className="alert-text font-weight-bold text-center">
                              {errors.reviewNotes}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                              <Form.Control
                                as="textarea"
                                name="reviewNotes"
                                values={values.reviewNotes}
                                onChange={handleChange}
                                type="text"
                                placeholder="Comments"
                                rows={5}
                                className={getInputClasses(
                                  "reviewNotes",
                                  touched,
                                  errors
                                )}
                                {...getFieldProps("reviewNotes")}
                                maxLength={1000}
                              />
                              <div className="d-flex justify-content-end">
                                {values.reviewNotes.length}/1000
                              </div>
                            </div>
                          </div>
              </Modal.Body>
              <Modal.Footer>
              <Button className="btn btn-secondary" onClick={onHide}>
                Cancel
              </Button>
              <Button className="btn btn-secondary" onClick={handleSubmit}>
                Set as Monitored
              </Button>
            </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
